
export default function(module) {
  module.filter('filterByName', function() {
    const _ = require('lodash')
    return function(elements, filterText) {
      return _.filter(elements, (ele) => _.lowerCase(ele.name).indexOf(_.lowerCase(filterText)) !== -1);
    }
  });

  module.controller("VerticalManagementController",  function(keywordService, providerService, confirmService, $uibModal) {
    const vm = this;
    vm.allProviders = [];
    providerService.allProviders().then(providers => {
      vm.allProviders = providers;
      vm.providersById = {};
      vm.allProviders.forEach(p => vm.providersById[p.id] = p)
    });

    function refresh(cached = true) {
      vm.isLoading = true;
      return keywordService.listVerticals(cached).then(results => {
        vm.verticals = results.verticals;
        vm.isLoading = false;
      })
    }

    refresh();

    vm.editVertical = function(vert) {
      $uibModal.open({
        template: require("./editVerticalModal.html"),
        controller: function($scope) {
          $scope.saving = false;
          $scope.allProviders = vm.allProviders;
          $scope.action = typeof vert === "undefined" ? "Add" : "Edit";
          $scope.vertical = vert || {providers: {}};
          $scope.selectedCount = () => _.count(_.values($scope.vertical.providers));

          $scope.save = () => {
            if (!$scope.addVerticalForm.$valid) {
              return;
            }
            $scope.saving = true;
            $scope.vertical.providers = $scope.vertical.providers.sort();
            keywordService.saveVertical($scope.vertical).then(done => {
              refresh(false);
              $scope.$close()
            })
          }
        }
      })
    }
    vm.deleteVertical = function(vertical) {
      confirmService.confirm("Delete Vertical", 'Deleting a vertical cannot be undone, are you sure you would like to remove the selected vertical?',
        confirmService.DELETE).then(agreed => {
        if (agreed) {
          keywordService.deleteVertical(vertical).then(() => {
            refresh(false);
          });
        }
      });
    }
  })
};
